<template>
  <nav
    class="side-menu-main scroll-invisible"
    :class="{ 'is-collapsed': !withTitles }"
  >
    <ul class="side-menu-list">
      <template v-if="withTitles">
        <primary-nav-item-with-title
          v-for="menuItem in visibleItems"
          :key="menuItem.toState"
          :menu-item="menuItem"
          :is-child-menu-active="menuItem.key === activeMenuItem"
          :has-children="expandableKeys.includes(menuItem.key)"
          :is-open="openKeys.includes(menuItem.key)"
          @toggle="toggle(menuItem.key)"
        >
          <slot :menu-key="menuItem.key" />
        </primary-nav-item-with-title>
      </template>
      <template v-else>
        <li v-for="menuItem in visibleItems" :key="menuItem.toState">
          <primary-nav-item
            :icon="menuItem.icon"
            :icon-src="menuItem.iconSrc"
            :name="menuItem.label"
            :to="menuItem.toState"
            :open-in-new-page="menuItem.openInNewPage"
            :is-child-menu-active="menuItem.key === activeMenuItem"
          />
        </li>
      </template>
    </ul>
  </nav>
</template>
<script>
import PrimaryNavItem from './PrimaryNavItem.vue';
import PrimaryNavItemWithTitle from './PrimaryNavItemWithTitle.vue';
import wootConstants from 'dashboard/constants/globals';

export default {
  components: {
    PrimaryNavItem,
    PrimaryNavItemWithTitle,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    withTitles: {
      type: Boolean,
      default: true,
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
    expandableKeys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      openKeys: [],
    };
  },
  computed: {
    visibleItems() {
      if (this.isACustomBrandedInstance) return this.menuItems;
      return [
        ...this.menuItems,
        {
          key: 'docs',
          icon: 'book-open-globe',
          label: 'DOCS',
          toState: wootConstants.DOCS_URL,
          openInNewPage: true,
        },
      ];
    },
  },
  watch: {
    activeMenuItem: {
      immediate: true,
      handler(key) {
        if (key && !this.openKeys.includes(key)) this.openKeys.push(key);
      },
    },
  },
  methods: {
    toggle(key) {
      this.openKeys = this.openKeys.includes(key)
        ? this.openKeys.filter(k => k !== key)
        : [...this.openKeys, key];
    },
  },
};
</script>
